import { FormData } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';
import { ChatBotData } from '~/training/sequence/templates/items/chatBot/types/ChatBotTypes';

export const populateFormWithChatBotData = (
  chatBotData: ChatBotData
): FormData => ({
  topic: chatBotData.template_vars.subject || '',
  questionCount: chatBotData.template_vars.num_questions || 3,
  sensitiveTopics: chatBotData.template_vars.notes || '',
  selectedTemplate: chatBotData.template_id?.toString() || '',
  level: chatBotData.template_vars.level || 'Intermediate'
});

export const createChatBotPayload = (formData: FormData) => ({
  subject: formData.topic,
  num_questions: formData.questionCount,
  notes: formData.sensitiveTopics,
  level: formData.level,
  course_authoring: true
});

export const createUpdateChatBotPayload = (formData: FormData) => ({
  conversation_bot: {
    settings: {
      template: {
        vars: {
          subject: formData.topic,
          num_questions: formData.questionCount,
          notes: formData.sensitiveTopics,
          level: formData.level
        }
      }
    }
  }
});

/**
 * Interpolates triple-bracket placeholders like [[[firstName]]] using values from context.
 * - Supports dotted paths: [[[user.firstName]]]
 * - Missing/undefined values are replaced with empty string
 */
export function interpolateTripleBrackets(
  text: string,
  context: Record<string, unknown>
): string {
  return (text || '').replace(
    /\[\[\[\s*([a-zA-Z0-9_.-]+)\s*\]\]\]/g,
    (_m, key) => {
      const parts = String(key).split('.');
      let current: unknown = context;
      for (let i = 0; i < parts.length; i += 1) {
        if (current && typeof current === 'object') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          current = (current as any)[parts[i]];
        } else {
          current = undefined;
          break;
        }
      }
      return current == null ? '' : String(current);
    }
  );
}
